import { useEffect, useState, memo } from "react";
import { Chart } from "primereact/chart";
import { Card } from "primereact/card";

const GraficoEvolucaoResiduo = memo(function GraficoEvolucaoResiduo({ months, residuosProduto, setor, selectedResiduo }) {
    const [chartData, setChartData] = useState(null);

    useEffect(() => {
        if (!selectedResiduo) {
            setChartData(null);
            return;
        }

        let filteredData = residuosProduto.filter(
            element => element.setor === setor && element.descricao === selectedResiduo
        );

        let values = months.map((monthStr, index) => {
            let mesData = filteredData.find(el => parseInt(el.mes) === index + 1);
            return mesData ? parseFloat(mesData.soma) : 0;
        });

        setChartData({
            labels: months,
            datasets: [
                {
                    label: `Evolução: ${selectedResiduo} (KG)`,
                    data: values,
                    fill: false,
                    borderColor: '#42A5F5',
                    backgroundColor: '#42A5F5',
                    tension: 0.4,
                    borderWidth: 2
                }
            ]
        });
    }, [months, residuosProduto, setor, selectedResiduo]);

    if (!chartData) {
        return (
            <div className="p-col-12 p-m-3">
                <Card style={{ height: "350px", display: "flex", justifyContent: "center", alignItems: "center", backgroundColor: "#f8f9fa", border: "1px dashed #ced4da" }}>
                    <p style={{ color: "#6c757d" }}>
                        <i className="pi pi-filter p-mr-2"></i>
                        Selecione um <b>Tipo de Resíduo</b> no filtro acima para visualizar o gráfico de evolução.
                    </p>
                </Card>
            </div>
        );
    }

    return (
        <div className="p-col-12 p-m-3">
            <Card>
                <Chart 
                    type="line" 
                    data={chartData} 
                    options={{ 
                        maintainAspectRatio: false,
                        plugins: {
                            legend: {
                                position: 'top',
                            }
                        }
                    }} 
                    height="350px" 
                />
            </Card>
        </div>
    );
});

export default GraficoEvolucaoResiduo;